import React, { useEffect } from 'react';

import { LocaleContext } from '../translations/LocaleContext';
import { LanguageCode } from '../translations';

interface Props {
  languageCode: LanguageCode;
  children: React.ReactNode;
}

export const LocaleProvider: React.FC<Props> = ({ languageCode, children }) => {
  const [locale, setLocale] = React.useState(languageCode);
  useEffect(() => {
    setLocale(languageCode);
  }, [languageCode]);
  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};
